<div class="status-dropdown-wrapper">
  <div class="label">{{ label() | translate }}:</div>
  <div class="btn-group status-dropdown" dropdown #dropdown="bs-dropdown" [autoClose]="true">
    <button dropdownToggle type="button" class="dropdown-toggle">
      <div
        class="status-pill"
        [ngStyle]="{ 'background-color': selectedStatus()?.color, 'color': getTextColor(selectedStatus()?.color) }"
      >
        {{ getStatusName(selectedStatus()?.name) }}
      </div>
    </button>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
      @for (status of statuses(); track status.name) {
        <li [ngStyle]="{ 'background-color': status.color, 'color': getTextColor(status.color) }"
            class="status-pill"
            (click)="onSelectStatus(status)">
          {{ getStatusName(status.name) }}
        </li>
      }
    </ul>
  </div>
</div>
